import {Module} from 'vuex';
import {RootState} from '@/store';
import {getters} from '@/store/modules/document/getters';
import {actions} from '@/store/modules/document/actions';
import {mutations} from '@/store/modules/document/mutations';
import {Documents, MissingDocument} from '@/models/form/Documents.model';

export interface DocumentState {
  documents: Documents;
  missingDocuments: MissingDocument[];
  loadingMode: boolean;
  removeMissingDocumentsFlag: boolean;
  uploadMissingDocumentsFlag: boolean;
  documentsErrors: string[];
}

export const initialState = ((): DocumentState => {
  return {
    documents: {
      employeeFiles: [],
      childrenFiles: [],
      extraIncomeFiles: [],
      handicapFiles: [],
      handicapMonthlyAllowanceFiles: [],
      settlementFiles: [],
      immigrantFiles: [],
      unemployedPartnerFiles: [],
      nonCustodyFiles: [],
      childSupportFiles: [],
      incompetentChildFiles: [],
      soldierFiles: [],
      academicFiles: [],
      reserveFiles: [],
      taxCoordsNoIncomeFiles: [],
      taxCoordsExternalIncomeFiles: [],
      taxCoordsApprovedFiles: []
    },
    missingDocuments: [],
    loadingMode: false,
    removeMissingDocumentsFlag: false,
    uploadMissingDocumentsFlag: false,
    documentsErrors: []
  };
});

export const document: Module<DocumentState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
